// @ts-nocheck
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from 'jitsi/base/environment/utils';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles()((theme, { isMobile }) => ({
    container: {
        zIndex: 1,
        marginTop: isMobile ? theme.spacing(4) : 20,
        position: 'absolute',
    },
    text: {
        marginBottom: theme.spacing(3),
        fontWeight: 700,
        color: theme.palette.iisightWhite,
        textAlign: 'center',
        fontSize: '14px',
        fontStyle: 'normal',
    },
}));
const isMobile = isMobileBrowser();
export const ConferenceName = () => {
    const { classes } = useStyles({ isMobile });
    const { t } = useTranslation();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
            React.createElement("h4", { className: classes.text, style: { marginBottom: '0px' } }, APP.room.name))));
};
